import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "languageandregion"
    }}>{`LanguageAndRegion`}</h1>
    <p>{`Used to specify a language and region.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`STANDARD_ARABIC`}</strong>{` = 1634877765`}</p>
      <p parentName="blockquote">{`Standard Arabic`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CZECH_REPUBLIC_CZECH`}</strong>{` = 1668498266`}</p>
      <p parentName="blockquote">{`Czech Republic: Czech`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DENMARK_DANISH`}</strong>{` = 1684096075`}</p>
      <p parentName="blockquote">{`Denmark: Danish`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`GERMANY_GERMAN`}</strong>{` = 1684358213`}</p>
      <p parentName="blockquote">{`Germany: German`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`GREECE_GREEK`}</strong>{` = 1701594962`}</p>
      <p parentName="blockquote">{`Greece: Greek`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`UNITED_KINGDOM_ENGLISH`}</strong>{` = 1701726018`}</p>
      <p parentName="blockquote">{`United Kingdom: English`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`UNITED_STATES_ENGLISH`}</strong>{` = 1701729619`}</p>
      <p parentName="blockquote">{`United States: English`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SPAIN_SPANISH`}</strong>{` = 1702053203`}</p>
      <p parentName="blockquote">{`Spain: Spanish`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FINLAND_FINNISH`}</strong>{` = 1718175305`}</p>
      <p parentName="blockquote">{`Finland: Finnish`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FRANCE_FRENCH`}</strong>{` = 1718765138`}</p>
      <p parentName="blockquote">{`France: French`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ISRAEL_HEBREW`}</strong>{` = 1751468364`}</p>
      <p parentName="blockquote">{`Israel: Hebrew`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HUNGARY_HUNGARIAN`}</strong>{` = 1752516693`}</p>
      <p parentName="blockquote">{`Hungary: Hungarian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ITALY_ITALIAN`}</strong>{` = 1769228628`}</p>
      <p parentName="blockquote">{`Italy: Italian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`JAPAN_JAPANESE`}</strong>{` = 1784760912`}</p>
      <p parentName="blockquote">{`Japan: Japanese`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`REPUBLIC_OF_KOREA_KOREAN`}</strong>{` = 1802455890`}</p>
      <p parentName="blockquote">{`Republic Of Korea: Korean`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NORWAY_NORWEGIAN`}</strong>{` = 1851936335`}</p>
      <p parentName="blockquote">{`Norway: Norwegian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NETHERLANDS_DUTCH`}</strong>{` = 1852591692`}</p>
      <p parentName="blockquote">{`Netherlands: Dutch`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`POLAND_POLISH`}</strong>{` = 1886146636`}</p>
      <p parentName="blockquote">{`Poland: Polish`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BRAZIL_PORTUGUESE`}</strong>{` = 1886667346`}</p>
      <p parentName="blockquote">{`Brazil: Portuguese`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RUSSIAN_FEDERATION_RUSSIAN`}</strong>{` = 1920291413`}</p>
      <p parentName="blockquote">{`Russian Federation: Russian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SWEDEN_SWEDISH`}</strong>{` = 1937134422`}</p>
      <p parentName="blockquote">{`Sweden: Swedish`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TURKEY_TURKISH`}</strong>{` = 1953649746`}</p>
      <p parentName="blockquote">{`Turkey: Turkish`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`UKRAINE_UKRAINIAN`}</strong>{` = 1969968449`}</p>
      <p parentName="blockquote">{`Ukraine: Ukrainian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SIMPLIFIED_CHINESE`}</strong>{` = 2053653326`}</p>
      <p parentName="blockquote">{`Simplified Chinese`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TRADITIONAL_CHINESE`}</strong>{` = 2053657687`}</p>
      <p parentName="blockquote">{`Traditional Chinese`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BELARUS_BELARUSIAN`}</strong>{` = 1650803289`}</p>
      <p parentName="blockquote">{`Belarus: Belarusian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BULGARIA_BULGARIAN`}</strong>{` = 1650934343`}</p>
      <p parentName="blockquote">{`Bulgaria: Bulgarian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ESTONIA_ESTONIAN`}</strong>{` = 1702118725`}</p>
      <p parentName="blockquote">{`Estonia: Estonian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CROATIA_CROATIAN`}</strong>{` = 1752320082`}</p>
      <p parentName="blockquote">{`Croatia: Croatian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LITUANIA_LITHUANIAN`}</strong>{` = 1819561044`}</p>
      <p parentName="blockquote">{`Lituania: Lithuanian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LATVIA_LATVIAN`}</strong>{` = 1819692118`}</p>
      <p parentName="blockquote">{`Latvia: Latvian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ROMANIA_ROMANIAN`}</strong>{` = 1919898191`}</p>
      <p parentName="blockquote">{`Romania: Romanian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SLOVAKIA_SLOVAK`}</strong>{` = 1936479051`}</p>
      <p parentName="blockquote">{`Slovakia: Slovak`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SLOVENIA_SLOVENIAN`}</strong>{` = 1936479049`}</p>
      <p parentName="blockquote">{`Slovenia: Slovenian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ALBANIA_ALBANIAN`}</strong>{` = 1936802124`}</p>
      <p parentName="blockquote">{`Albania: Albanian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`INDIA_TAMIL`}</strong>{` = 1952532814`}</p>
      <p parentName="blockquote">{`India: Tamil`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`THAILAND_THAI`}</strong>{` = 1952994376`}</p>
      <p parentName="blockquote">{`Thailand: Thai`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`VIETNAM_VIETNAMESE`}</strong>{` = 1986614862`}</p>
      <p parentName="blockquote">{`Vietnam: Vietnamese`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`INDIC`}</strong>{` = 1768842345`}</p>
      <p parentName="blockquote">{`Indic`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      